.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.section {
  display: flex;
  flex-direction: row;
  gap: var(--space-lg);

  nav {
    padding: 0;
    flex: 0 0 19.5rem;
  }
}

.deceasedCandidatesTable {
  width: fit-content;
}

.resetSection {
  display: flex;
  gap: var(--space-sm);
  align-items: center;
  margin-top: var(--space-md);

  svg {
    fill: var(--base-black);
  }
  a {
    text-decoration: none;
  }
}
